var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayButton = function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 137,
    viewBox: "0 0 136 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.3694 71.9316C99.9783 70.3814 99.9783 66.6044 97.3694 65.0542L54.1522 39.3742C51.4859 37.7898 48.1089 39.7114 48.1089 42.8129V94.1729C48.1089 97.2745 51.4859 99.196 54.1522 97.6116L97.3694 71.9316Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68.627,
    r: 63,
    stroke: "white",
    strokeWidth: 10
  })));
};
export default SvgPlayButton;